<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { ModelListSelect } from "vue-search-select";
import {mapGetters, mapActions, mapState} from "vuex";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import axios from "axios";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Culture & Sensitivity Section",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
    ckeditor: CKEditor.component,
  },
  data() {
    return {
      editor: ClassicEditor,
      title: "Culture & Sensitivity Results",
      items: [
        {
          text: "Laboratory Section",
          href: "#",
        },
        {
          text: "Culture & Sensitivity Results",
          active: true,
        },
      ],

      order: this.$route.params,
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      filter: null,
      filterOn: [],
      sortBy: "id",
      sortDesc: true,
      thisTest: "",
      model_id:"",
      organismError:"",
      resultError:"",
      drugError:"",
      results:[
        {value:'R', label:'Resistant'},{value:'I', label:'Intermediate'},{value:'S', label:'Sensitive'}
      ],
      data: {
        serviceId: this.$route.params.serviceId,
        visitId: this.$route.params.visitId,
        organism: "",
      },
      toResult: {
        testName: "",
        antibiotic: "",
        zone: "",
        result: "",
        microresult_id: "",
        serviceId: this.$route.params.serviceId,
        visitId: this.$route.params.visitId,
      },
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "organism",
          sortable: true,
          label: "ORGANISM(S) ISOLATED",
        },
        {
          key: "result_detail",
          sortable: true,
          label: "ANTIBIOTIC(S)",
        },
        {
          key: "action",
          sortable: false,
          label: "ACTION",
        },
      ],
      toDelete:{
        testName: "",
        id:"",
        serviceId: this.$route.params.serviceId,
        visitId: this.$route.params.visitId,
      },
      drugDelete:{
        serviceId: this.$route.params.serviceId,
        visitId: this.$route.params.visitId,
        drug:"",
        zone:"",
        result:"",
        id:"",
      },
      drugEdit:{
        serviceId: this.$route.params.serviceId,
        visitId: this.$route.params.visitId,
        drug:"",
        drug_id:"",
        id:"",
      },
    };
  },

  computed: {
    ...mapGetters("laboratory", [
      "test_detail",
      "organisms",
      "microbio_results",
      "antibiotics",
      "AddingResultStatus",
    ]),
    ...mapGetters("staffModule", ["clinic_staff"]),
    ...mapGetters("auth", ["user_permissions"]),
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    rows() {
      return this.microbio_results ? this.microbio_results.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.microbio_results ? this.microbio_results.length : 1;
  },

  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeMode(this.model_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }},
    },


  updated() {
    this.thisTest = this.test_detail;
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    //=============================================
    saveOrganism(modalId) {
      this.model_id=modalId;
      if (this.data.organism === "") {
        this.organismError="Organism field is required";
        return;
      }
      // dispatch the saving action
      this.saveTestOrganism(this.data);
    },

    resetOrganismModal() {
      this.data.organism = "";
      this.organismError="";
    },

    //===========================================
    showResultModal(data) {
      (this.toResult.testName = data.item.organism),
        (this.toResult.antibiotic = ""),
        (this.toResult.zone = ""),
        (this.toResult.result = ""),
        (this.toResult.microresult_id = data.item.id);
    },

    saveResult(modelId) {
      this.model_id =modelId;
      if (this.toResult.antibiotic === "") {
        this.drugError="Drug/Antibiotic field is required";
        return;
      }
      if (this.toResult.result === "") {
        this.resultError="Susceptibility result field is required";
        return;
      }
      // dispatch the saving action
      this.saveTestResult(this.toResult)
    },

    resetResultModal() {
      (this.toResult.testName = ""),
        (this.toResult.antibiotic = ""),
        (this.toResult.zone = ""),
        (this.toResult.result = ""),
        (this.drugError = ""),
        (this.resultError = ""),
        (this.toResult.microresult_id = "");
    },

    //=======================================
    DeleteOrganismShow(data){
          this.toDelete.testName = data.item.organism
          this.toDelete.id = data.item.id
    },

    deleteOrganism(modelId){
      this.model_id=modelId;
    // Dispatch to the end point
      this.deleteTestOrganism(this.toDelete);
    },

    resetDeleteModal(){
      this.toDelete.testName = ""
      this.toDelete.id = ""
    },

    //=======================================
    deleteDrugShow(data){
      this.drugDelete.drug = data.antibiotic
      this.drugDelete.id = data.id
    },

    deleteDrug(modelId){
      this.model_id=modelId;
// Dispatch to the end point
      this.deleteTestDrug(this.drugDelete);
    },

    resetDeleteDrug(){
      this.drugDelete.drug = ""
      this.drugDelete.id = ""
    },

    //=======================================
    editDrugShow(data){
      this.drugEdit.drug = data.antibiotic
      this.drugEdit.drug_id = data.antibiotic_id
      this.drugEdit.id = data.id
      this.drugEdit.zone = data.zone
      this.drugEdit.result = data.result
    },

    saveChanges(modelId){
      this.model_id=modelId;
// Dispatch to the end point
      this.editTestDrug(this.drugEdit);
    },

    resetEditDrug(){
      this.drugEdit.drug = ""
      this.drugEdit.drug_id = ""
      this.drugEdit.id = ""
      this.drugEdit.zone = ""
      this.drugEdit.result = ""
    },


    markAsComplete() {
      axios.post("complete_test", this.thisTest)
        .then(() => this.$router.push("/laboratory/pending"));
    },

    resetSMS(){
      this.organismError="";
      this.drugError="";
      this.resultError="";
    },

    // CLOSE MODEL
    closeMode(model_id) {
      this.$nextTick(() => {
        this.$bvModal.hide(model_id);
      });
    },

    ...mapActions({
      MicrobioTestDetail: "laboratory/fetchTestDetail",
      LoadOrganisms: "laboratory/fetchOrganisms",
      TestResults: "laboratory/fetchTestResults",
      LoadAntibiotics: "laboratory/fetchAntibiotics",
      saveTestOrganism: "laboratory/addTestOrganism",
      deleteTestOrganism: "laboratory/deleteTestOrganism",
      deleteTestDrug: "laboratory/deleteTestDrug",
      editTestDrug: "laboratory/editTestDrug",
      saveTestResult: "laboratory/addMicrobioResult",
    }),
  },
  created() {
    this.MicrobioTestDetail(this.order);
    this.LoadOrganisms();
    this.TestResults(this.order);
    this.LoadAntibiotics();
  },
};
</script>

<template>
  <Layout>
    <Toasts
        :show-progress="true"
        :rtl="true"
        :max-messages="20"
        :time-out="3000"
        :closeable="false"
        :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body" v-if="test_detail">
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_long" class="dataTables_length">
                  <h4 class="card-title text-uppercase">
                    {{ test_detail.labtest }} susceptibility result
                  </h4>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filters"
                  class="dataTables_filter text-md-end">
                  <b-button variant="primary" v-b-modal.organism-modal><i class="fa fa-plus"></i> New organism</b-button>
                </div>

                <!-- == add organism modal -->
                <b-modal
                  id="organism-modal"
                  ref="modal" hide-footer
                  @hidden="resetOrganismModal"
                >
                  <template #modal-title>
                    <p class="text-uppercase">Add New Organism</p>
                  </template>

                  <div class="mb-3">
                    <label class="col-form-label">Select an Organism:</label>
                    <model-list-select :list="organisms ? organisms : []" v-model="data.organism" option-value="id"
                                       option-text="organism" placeholder="Select Organism" @input="resetSMS">
                    </model-list-select>
                    <div class="text-danger" v-if="organismError">
                      <em>{{organismError}}</em>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button class="btn btn-secondary"  @click="$bvModal.hide('organism-modal')" type="button">Close</button>
                    <button class="btn btn-primary" type="button" @click="saveOrganism('organism-modal')">
                      Save result
                      <b-spinner
                          v-if="AddingResultStatus"
                          variant="light" small
                          role="status"
                      ></b-spinner>
                    </button>
                  </div>
                </b-modal>

                <!-- delete organism modal  -->
                <b-modal id="delete-organism" @hidden="resetDeleteModal" hide-footer>
                  <template #modal-title>
                    <p class="text-uppercase">{{ toDelete.testName }} deleting</p>
                  </template>
                  <div class="d-block text-center">
                    <h3>
                      You're deleting <code>{{ toDelete.testName }}</code>.
                      <br />
                      Click <code>CONFIRM</code> to continue
                    </h3>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary"  @click="$bvModal.hide('delete-organism')" type="button">Close</button>
                    <button class="btn btn-primary" type="button" @click="deleteOrganism('delete-organism')">
                      Confirm
                      <b-spinner
                          v-if="AddingResultStatus"
                          variant="light" small
                          role="status"
                      ></b-spinner>
                    </button>
                  </div>
                </b-modal>

                <!-- delete Drug modal  -->
                <b-modal id="delete-drug" @hidden="resetDeleteDrug" hide-footer>
                  <template #modal-title>
                    <p class="text-uppercase">{{ drugDelete.drug }} deleting</p>
                  </template>
                  <div class="d-block text-center">
                    <h3>
                      You're deleting <code>{{ drugDelete.drug }}</code>.
                      <br />
                      Click <code>CONFIRM</code> to continue
                    </h3>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-secondary"  @click="$bvModal.hide('delete-drug')" type="button">Close</button>
                    <button class="btn btn-primary" type="button" @click="deleteDrug('delete-drug')">
                      Confirm
                      <b-spinner v-if="AddingResultStatus" variant="light" small role="status"></b-spinner>
                    </button>
                  </div>
                </b-modal>

                <!-- add result modal  -->
                <b-modal id="result-modal" ref="modal" @hidden="resetResultModal" hide-footer>
                  <template #modal-title>
                    <p class="text-uppercase">Add New Drug/Antibiotic</p>
                  </template>

                  <div class="mb-3">
                    <label class="col-form-label">Select Drug/Antibiotic:</label>
                    <model-list-select :list="antibiotics ? antibiotics : []" v-model="toResult.antibiotic" @input="resetSMS" option-value="id" option-text="antibiotic" placeholder="Select Drug/antibiotic">
                    </model-list-select>
                    <div class="text-danger" v-if="drugError">
                      <em>{{drugError}}</em>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label>Zone Diameter</label>
                    <input type="number" class="form-control" v-model="toResult.zone"/>
                  </div>

                  <div class="mb-3">
                    <label class="col-form-label">Select susceptibility result:</label>
                    <model-list-select :list="results ? results : []" v-model="toResult.result" @input="resetSMS" option-value="value" option-text="label" placeholder="Select Susceptibility Result">
                    </model-list-select>
                    <div class="text-danger" v-if="resultError">
                      <em>{{resultError}}</em>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button class="btn btn-secondary"  @click="$bvModal.hide('result-modal')" type="button">Close</button>
                    <button class="btn btn-primary" type="button" @click="saveResult('result-modal')">
                      Save result
                      <b-spinner
                          v-if="AddingResultStatus"
                          variant="light" small
                          role="status"
                      ></b-spinner>
                    </button>
                  </div>
                </b-modal>

                <!-- add result modal  -->
                <b-modal id="result-edit" ref="modal" @hidden="resetEditDrug" hide-footer>
                  <template #modal-title>
                    <p class="text-uppercase">Edit {{drugEdit.drug}} results</p>
                  </template>

                  <div class="mb-3">
                    <label class="col-form-label">Select Drug/Antibiotic:</label>
                    <model-list-select :list="antibiotics ? antibiotics : []" v-model="drugEdit.drug_id"
                                       @input="resetSMS"
                                       option-value="id" option-text="antibiotic" placeholder="Select Drug/antibiotic">
                    </model-list-select>
                    <div class="text-danger" v-if="drugError">
                      <em>{{drugError}}</em>
                    </div>
                  </div>

                  <div class="mb-3">
                    <label>Zone Diameter</label>
                    <input type="number" class="form-control" v-model="drugEdit.zone"/>
                  </div>

                  <div class="mb-3">
                    <label class="col-form-label">Select susceptibility result:</label>
                    <model-list-select :list="results ? results : []" v-model="drugEdit.result" @input="resetSMS" option-value="value" option-text="label" placeholder="Select Susceptibility Result">
                    </model-list-select>
                    <div class="text-danger" v-if="resultError">
                      <em>{{resultError}}</em>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button class="btn btn-secondary"  @click="$bvModal.hide('result-edit')" type="button">Close
                    </button>
                    <button class="btn btn-primary" type="button" @click="saveChanges('result-edit')">
                      Save result
                      <b-spinner
                          v-if="AddingResultStatus"
                          variant="light" small
                          role="status"
                      ></b-spinner>
                    </button>
                  </div>
                </b-modal>

              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length"></div>
              </div>

              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <div class="table-responsive mb-0">
              <b-table
                bordered foot-clone
                class="datatables"
                :items="microbio_results"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(result_detail)="data">
                  <table class="table">
                    <thead>
                      <tr>
                        <th>Antibiotic</th>
                        <th>Zone Diameter</th>
                        <th>Result</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(result, r) in data.item.result_details"
                        :key="r"
                      >
                        <td>{{ result.antibiotic }}</td>
                        <td>{{ result.zone }}</td>
                        <td>{{ result.result }}</td>
                        <td>
                          <b-button size="sm" v-b-modal.result-edit title="Edit Susceptibility result"
                                    variant="success" @click="editDrugShow(result)"><i class="fa fa-edit">
                          </i></b-button> |
                          <b-button size="sm" v-b-modal.delete-drug variant="danger" title="Delete Susceptibility result" @click="deleteDrugShow(result)"><i
                              class="fa fa-trash-alt"></i></b-button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </template>
                <template #cell(action)="data">
                  <!-- add results -->
                  <b-button squared class="p-2" v-b-modal.result-modal variant="secondary m-1"
                            title="Add drug susceptibility result" @click="showResultModal(data)"><i
                      class="fa fa-plus"></i> Add
                  </b-button>

                  <!-- add results -->
                  <b-button squared v-b-modal.delete-organism variant="danger m-1" title="Remove an isolated organism"
                            @click="DeleteOrganismShow(data)"><i
                      class="fa fa-trash"></i>
                  </b-button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="mt-3 text-info font-weight-bold"
                ><h4 class="mt-3 text-info font-weight-bold">
                  Comments
                </h4></label
              >
              <ckeditor v-model="thisTest.comment" :editor="editor"></ckeditor>
            </div>
            <div class="d-flex justify-content-end mt-3">
              <button class="btn btn-primary mt-3" @click="markAsComplete">
                <i class="fa fa-check"></i>
                Mark as complete
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
